import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { waitFor } from '@ember/test-waiters';
import Component from '@glimmer/component';
import { restartableTask, timeout } from 'ember-concurrency';
import type ActionModel from 'frontend/models/action';
import { tracked } from 'tracked-built-ins';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type FetchService from '@triptyk/ember-utils/services/fetch';

export interface SearchInputComponentArgs {
  current: string | undefined;
  onChange?: (value: string, e: Event) => unknown;
  onSearch: (value: string) => unknown;
}

export default class SearchInputComponent extends Component<SearchInputComponentArgs> {
  @service declare store: Store;
  @service declare fetch: FetchService;
  @tracked actionOptions: Record<string, unknown>[] = [];
  @tracked searchValue: string = '';

  constructor(owner: unknown, args: SearchInputComponentArgs) {
    super(owner, args);
    assert(
      'Please provide @onSearch to search input',
      args.onSearch !== undefined
    );
    if (args.current) {
      this.searchValue = args.current;
    }
  }

  @action
  updateSearchValue(v: string) {
    this.searchValue = v;
  }

  @action
  onSearch(e: Event) {
    // prevent to submit form
    e.preventDefault();
    this.args.onSearch(this.searchValue);
  }

  @restartableTask
  @waitFor
  *searchAction(search: string) {
    yield timeout(200);

    const actions: { data: Record<string, unknown>[] } = yield this.fetch
      .request(`search/suggest?q=${search}`)
      .then((res) => res.json());

    this.actionOptions = actions.data;
  }

  @action
  setSearchAction(action: ActionModel | string) {
    if (typeof action === 'string') {
      this.args.onSearch(action);
      return;
    }

    this.args.onSearch(action.name);
  }
}
